// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FiUserX = function FiUserX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "8",
        "x2": "23",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "23",
        "y1": "8",
        "x2": "18",
        "y2": "13"
      }
    }]
  })(props);
};